/**
 * @generated SignedSource<<c95485b02e541769a0c60e19c429372e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchPageContentFragment$data = {
  readonly contentUsage: {
    readonly " $fragmentSpreads": FragmentRefs<"BrainSearchInput_ContentUsageFragment">;
  } | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchMessageList_PaginationFragment" | "BrainSearchPageHeaderFragment">;
  readonly " $fragmentType": "BrainSearchPageContentFragment";
};
export type BrainSearchPageContentFragment$key = {
  readonly " $data"?: BrainSearchPageContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchPageContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchPageContentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BrainSearchPageHeaderFragment"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "kind": "FragmentSpread",
      "name": "BrainSearchMessageList_PaginationFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsage",
      "kind": "LinkedField",
      "name": "contentUsage",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BrainSearchInput_ContentUsageFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrainSearch",
  "abstractKey": null
};

(node as any).hash = "380b1db872c009588e7a82aeb8afe0d1";

export default node;
